import React,{useEffect,useState,Fragment} from 'react';
import {useHistory,Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import styled from 'styled-components';
import Panel from '../components/Panel';
import Content from '../components/Content';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'



const Thanks = (props) => {

    const [q1,getQ1] = useState();
    const [isAnswered,setIsAnswered] = useState(false);
    const history = useHistory();
    const [isExtraOpen, setIsExtraOpen] = useState(false);
    const [getName, setGetName] = useState("");
    const [getEmail, setGetEmail] = useState("");

  const updateName = (e) => {
    let t = e.currentTarget.value;
    setGetName(t);
  };

  const updateEmail = (e) => {
    let t = e.currentTarget.value;
    setGetEmail(t);
  };

    const getInput = e => {
        const t = e.currentTarget.value;
        getQ1(t);
    }

    const checkInput = e => {
        setIsAnswered(true)
        e.preventDefault();
    }

    return(
        <HomePage>
            <Panel w={50} setBG="ty">
                <SlideTitle>thank <br />you</SlideTitle>
            </Panel>
            <Content noTab>
                <p>If you want to drive continuous improvement with optimized workflows that run on any BSS/OSS, and achieve business impacting results, we invite you to download the whitepaper <a style={{color: '#EAB330'}} href="https://www.amdocs.com/insights/redesigning-business-processes-improve-cx" target="_blank"><b>Redesigning business processes to improve CX</b></a>.</p>
            </Content>
           
    
        </HomePage>
    )
}


const InputBox = styled.input`
  border: 1px solid #fff;
  background: none;
  padding: 10px;
  display: block;
  margin: 10px 0;
  width: 100%;
  color: #fff;


  ::placeholder {
  color: #fff;
  opacity: 1; /* Firefox */
}
`;


const HomePage = styled(motion.div)`
    width: 100%;
    height: 100%;
    overflow-x: hidden !important;
    display: flex;

    @media (max-width: 1060px) {
    flex-direction: column;
}
    
`;

const SlideTitle = styled.h1`
    font-family: 'MarkPro-Black';
    font-size: 3.5em;
    max-width: 60%;
    text-align: right;
    margin-left: auto;
    position: relative;
    left: 50px;
    z-index: 10;

    @media (max-width: 1060px) {
           font-size: 3em;
            left: 0;
           top: 30px;
           margin-right: 0;
           margin-left: unset;
           text-align: center;
            max-width: 75%;
        }
`;

const StartButton = styled.div`
    font-family: 'MarkPro-Black';
    color: #fff;
    background: #EAB330;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 2em;
    padding: 15px;
    cursor: pointer;

    @media (max-width: 1060px) {
        position: static;
        margin-top: 20px;
    }
`;


const Ar = styled(FontAwesomeIcon)`
    color: #333147;
    fill: #333147;
    margin-left: 20px;
`;

export default Thanks;